import {
  GraduatedPrice,
  PriceEditorPercentageTier,
  PriceEditorTier,
  VolumePrice
} from 'common/drawers/PricingEditor/domain'
import {
  decimalFromPercentage,
  formatInteger,
  toMoney
} from '@sequencehq/utils'

type PriceTierTableRow = {
  firstUnit: string
  lastUnit: string
  perUnit: string
  flatFee: string
}

export const percentageFormatter = (percentage: string) =>
  Number(decimalFromPercentage(percentage)).toLocaleString(undefined, {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 10
  })

export const priceTierRowFormatter = (
  tier: PriceEditorTier | PriceEditorPercentageTier,
  index: number,
  tiers: Array<PriceEditorTier | PriceEditorPercentageTier>,
  price: VolumePrice | GraduatedPrice
): PriceTierTableRow => {
  const previousTier = tiers[index - 1]
  const flatFee =
    Number(tier?.flatFee) > 0
      ? toMoney({
          currency: price.common.currency,
          value: tier.flatFee,
          maximumFractionDigits: 10
        })
      : ''

  if ('unitPercentage' in tier) {
    const firstUnit = previousTier?.lastUnit
      ? toMoney({
          currency: price.common.currency,
          value: (Number.parseFloat(previousTier.lastUnit) + 0.01).toString(),
          maximumFractionDigits: 10
        })
      : toMoney({
          currency: price.common.currency,
          value: '0',
          maximumFractionDigits: 10
        })

    const lastUnit = tier?.lastUnit
      ? toMoney({
          currency: price.common.currency,
          value: tier.lastUnit,
          maximumFractionDigits: 10
        })
      : '∞'

    const perUnit = percentageFormatter(tier.unitPercentage)

    return { firstUnit, lastUnit, perUnit, flatFee }
  }

  const firstUnit = previousTier?.lastUnit
    ? formatInteger()(Number(previousTier.lastUnit) + 1)
    : '0'

  const lastUnit = tier?.lastUnit ? formatInteger()(tier.lastUnit) : '∞'

  const perUnit = toMoney({
    currency: price.common.currency,
    value: tier.unitPrice,
    maximumFractionDigits: 10
  })

  return { firstUnit, lastUnit, perUnit, flatFee }
}
